import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField, { type TextFieldProps } from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

/**
 * A password box with an eye to show what was typed (owner 2026-10-25: "all
 * password ... should have eye signed so that user ensure what password they
 * entered"). Hidden by default; the eye shows only what this person typed
 * here, never a stored value. Every TextField prop passes through, so
 * autoComplete ("current-password" / "new-password") is kept.
 */
export function PasswordField(props: Omit<TextFieldProps, "type">) {
  const [shown, setShown] = useState(false);
  return (
    <TextField
      {...props}
      type={shown ? "text" : "password"}
      slotProps={{
        ...props.slotProps,
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={shown ? "Hide password" : "Show password"}
                onClick={() => setShown((s) => !s)}
                onMouseDown={(e) => e.preventDefault()}
                edge="end"
                size="small"
                tabIndex={-1}
              >
                {shown ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
